import axios from 'axios';
let appConfig = {};
try {
        appConfig = JSON.parse(window.VINCENT_DATA);
} catch (e) {}
const API_URL = appConfig.api_url || 'http://localhost:8000/cvdp';
const SCORE_API_URL = appConfig.score_api_url || 'http://localhost:8000/score';
const LOGOUT_URL = appConfig.logout_url || 'http://localhost:8000/accounts/logout/';
const INACTIVITY_TIMEOUT = appConfig.inactivity_timeout || null;

axios.defaults.xsrfHeaderName = "X-CSRFToken"
axios.defaults.xsrfCookieName = 'csrftoken'


class TermsAPI {


    constructor(baseUrl) {
	// 1. Initialize the instance here
	this.api = axios.create();

    }
    
    updateSession() {
        const url = `${API_URL}/api/session/ping/`;
        return this.api.post(url, {}).then(response => response.data);
    }

    checkTermsStatus() {
        const url = `${API_URL}/api/terms/`;
        return this.api.get(url).then(response => response.data);
    }


    getTermsAndConditions() {
        const url=`${API_URL}/api/terms/update/`;
        return this.api.get(url).then(response => response.data);
    }

    updateTermsAndConditions(data) {
        const url=`${API_URL}/api/terms/update/`;
        return this.api.patch(url, data).then(response => response.data);
    }

    acceptTerms() {
        const url = `${API_URL}/api/terms/`;
        return this.api.post(url, {}).then(response => response.data);
    }

    rejectTerms() {
        const data={'reject': true}
        const url = `${API_URL}/api/terms/`;
        return this.api.post(url, data).then(response => response.data);
    }

    logoutUser() {
        const data = {}
        return this.api.post(LOGOUT_URL, data).then(response => response.data);
    }

}

const termsapi = new TermsAPI();
export default termsapi;
